import { START_LOADING, END_LOADING } from "./loading_actions";
import { postResendActivation } from "../../utils/api";
import { SET_PORTAL_API } from "./portal_actions";
import {
  TITLE_NOTIFICATION, TITLE_ERROR, RESEND_ACTIVATION_SUCCESS
} from "../../utils/constants";

export const EDIT_EMAIL_RESEND = 'EDIT_EMAIL_RESEND';
export const RESET_RESENT_FORM = 'RESET_RESENT_FORM';
export const REQUEST_RESEND_ACTIVATION = 'REQUEST_RESEND_ACTIVATION';
export const REQUEST_RESEND_ACTIVATION_SUCCESS = 'REQUEST_RESEND_ACTIVATION_SUCCESS';
export const REQUEST_RESEND_ACTIVATION_FAILED = 'REQUEST_RESEND_ACTIVATION_FAILED';


export const postResendActivationThunk = (email, navigate) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_RESEND_ACTIVATION });
    postResendActivation(email)
      .then(data => {
        dispatch({ type: REQUEST_RESEND_ACTIVATION_SUCCESS });
        dispatch({ type: RESET_RESENT_FORM });
        navigate("/", { replace: true });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: RESEND_ACTIVATION_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({ type: REQUEST_RESEND_ACTIVATION_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      })
  }
}
